import { StorageService } from '../services/storageService';
import { SETTING_DISABLED } from '../constants';

export const getStorageSettings = (settingsKey: string) =>
  Boolean(parseInt(StorageService.getItem(settingsKey, SETTING_DISABLED)));
